import axios from "axios";
import { API_BASE_URL } from "../config/config";

// const currentDomain = window.location.hostname; // Örn: "localhost" veya "www.example.com"

// const API_BASE_URL =
//   currentDomain === "localhost" ||
//   currentDomain === "127.0.0.1" ||
//   currentDomain === "aiconnect.com.tr" ||
//   currentDomain === "demo.aiconnect.com.tr"
//     ? "https://apis.aiconnect.com.tr/reportautodialer"
//     : `https://apis.${currentDomain}/reportautodialer`;

const ReportAutodialerService = {
  list: (data) => {
    const params = new URLSearchParams({
      start: data.start,
      size: data.size,
      filters: data.filters,
      globalFilter: data.globalFilter,
      sorting: data.sorting,
      startDate: data.startDate,
      endDate: data.endDate,
      accountcode: data.accountcode,
      token: data.token,
      userID: data.userID,
      numberpoolid: data.numberpoolid,
    });
    return axios.get(
      `${API_BASE_URL}/reportautodialer/list?${params.toString()}`
    );
  },
  downloadAll: (data) => {
    const params = new URLSearchParams({
      start: data.start,
      size: data.size,
      filters: data.filters,
      globalFilter: data.globalFilter,
      sorting: data.sorting,
      accountcode: data.accountcode,
      token: data.token,
      userID: data.userID,
      numberpoolid: data.numberpoolid,
    });
    return axios.get(
      `${API_BASE_URL}/reportautodialer/reportDownloadAll?${params.toString()}`
    );
  },
};

export default ReportAutodialerService;
